<template>
    <div id="WorkOrderTemplateList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Work Order Template List</div>
                    <router-link v-if="canAddWOTemplate" class="btn btn-primary pull-right" v-bind:to="{name: 'WorkOrderTemplateCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content work-order-lists">
                        <data-table-filter-config :moduleName="'wotList'" ref="filterWot" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'wotList'" :position="'top'">
                            </custom-pagination>

                            <vue-good-table
                                ref="listWorkOrderTemplateTable"
                                mode="remote"
                                title="WorkOrderTemplate"
                                @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="userColumns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    dropdownAllowAll: false,
                                }"
                                :select-options="{
                                    enabled: work_order_template_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                                :search-options="{
                                enabled: false,
                                }">
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <a v-if="canUpdateWOTemplate === true" title="Delete Template" v-on:click.prevent="removeLine(props.row.id)" class="fp-delete mr-3" style="cursor:pointer"></a>
                                            <template v-if="canUpdateWOTemplate">
                                                <router-link title="Edit Template" class="fp-edit" v-bind:to=" {name: 'WorkOrderTemplateEdit',params:{id:props.row.id}}"></router-link>
                                            </template>
                                            <!-- <template v-if="canUpdateWOTemplate">
                                                <router-link title="Edit Template" class="glyphicon glyphicon-eye-open" v-bind:to=" {name: 'RecallAssetMapper',params:{id:props.row.id}}"></router-link>
                                            </template> -->
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions">
                                    <button v-bind:key="'delete'" v-if="canDeleteWOTemplate === true" id="deleteShopBtn" v-on:click.prevent="ShopDelete" class="btn btn-primary">Delete</button>
                                </div>
                            </vue-good-table>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
    export default {
        name: "WorkOrderTemplateList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Work Order Template List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            permissions: [],
            cantAccessPage: "",
            firstLoad: 0,
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable:false
                },
                {
                    label: 'Maintenance Type',
                    field: 'maintenanace_type',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Maintenance Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Recall Name',
                    field: 'recall_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    sortable:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Recall Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            work_order_template_value: false,
            loading:false,
            canDeleteWOTemplate: false,
            canAddWOTemplate: false,
            canUpdateWOTemplate: false
        }),
        watch:{
            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_work_order_template') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_work_order_template') {
                            self.canAddWOTemplate = true;
                            self.canUpdateWOTemplate = true;
                        }
                        if (permissions[i].name == 'delete_work_order_template') {
                            self.canDeleteWOTemplate = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        beforeMount: function () {
            var self = this;
            self.getPermissions();
        },
        mounted: function() {
            var self = this;

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listWorkOrderTemplateTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/workordertemplate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false,'workorder-template-list');
                    }
                });
            },
            removeLine (id) {

                var self = this;

                if (confirm('Are you sure that you want to remove this line? ')) {

                    $.ajax({
                        url: process.env.ROOT_API + "/workordertemplate/delete",
                        type: "POST",
                        data: {'id': id},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            if (data.status == "success") {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, false,'workorder-template-remove-item');
                        },
                    });
                }


            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/WorkOrderTemplateList.vue